import {Component, Input} from 'ng-metadata/core';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';

@Component({
    selector: 'prm-resource-recommender-card-content',
    templateUrl: 'components/search/resourceRecommender/resource-recommender-card-content.html',
})

export class PrmResourceRecommenderCardContent {
    @Input() private resource;
    @Input() private index;

    constructor(private primolyticsService: PrimolyticsService) {

    }


    private handle_click() {
        this.report_beacon(this.resource);
    }

    @beacon({'p':'brief', 'op': 'resourceRecommender'})
    private report_beacon(resource) {

    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/resourceRecommenderCardContent.directive.ts